export const linkApi = "https://dev.api.coe.bmte.vn";
export const LAO_API = "https://api.laos.coe.bmte.vn";

export const SCREEN_DEFAULT = {
  1: "/dashboard",
  2: "/survey_urls",
  3: "/raw_data",
  4: "/documents",
  6: "/exportData",
  7: "/user_management",
};

export const screenReverst = {
  dashboard: 1,
  survey_urls: 2,
  raw_data: 3,
  documents: 4,
  user_management: 5,
};
